import { Subject } from 'rxjs';

const subject = new Subject();

export const SalvarTarefaSubjectService = {
    sendSalvar: (salvar: boolean) => subject.next(salvar),
    getSalvar: () => subject.asObservable()
};